export default {
    http: 'https',
    // domainName: 'vadagap-local.ir/api/ ',
    domainName: 'vadaroom.ec.iau.ir/api/v1/',
    staticPath:'https://192.168.12.55:44390/api/v1'
}